import * as globalData from "views/constants/jsonData/globalData"

import { userStateAction } from "./action"

const initialState = {
  userData: undefined, // use undefined before check status
  ownedScooter: {
    scooter1: globalData.nonUid,
    scooter2: globalData.nonUid,
  },
  testrideBooked: false,
  recaptcha: null,
  isGlobe: undefined,
  dataCompany: undefined,
}

export function userStateReducer(state = initialState, action) {
  switch (action.type) {
    case userStateAction.SET_USER_STATE: {
      return Object.assign({}, state, action.payload)
    }
    case userStateAction.SET_IS_GLOBE: {
      return Object.assign({}, state, {
        isGlobe: action.payload,
      })
    }
    case userStateAction.SET_DATA_COMPANY: {
      return Object.assign({}, state, {
        dataCompany: action.payload,
      })
    }

    case userStateAction.USER_LOGOUT_SUCCESS: {
      return Object.assign({}, state, {
        userData: null,
        ownedScooter: {
          scooter1: globalData.nonUid,
          scooter2: globalData.nonUid,
        },
      })
    }

    case userStateAction.SELECT_USER_SCOOTER: {
      let newState = { ...state }

      newState.ownedScooter[action.payload.name] = action.payload.value

      return newState
    }
    case userStateAction.SET_RECAPTCHA_STATUS: {
      return { ...state, recaptcha: action.payload.recaptcha }
    }
    default:
      return state
  }
}
